import { Button } from "@mui/material";
import {
  Show,
  Tab,
  TabbedShowLayout,
  useRecordContext,
  useRefresh,
} from "react-admin";
// import AreaMetaShow from "./AreaMetaShow";
// import AreaServicesTab from "./AreaServicesTab";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
// import {useAppSelector} from "../../store/hooks";
import React, { useState } from "react";
import ComboMetaShow from "./ComboMetaShow";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import ComboService from "../../services/ComboService";
import { PaymentLinkDailog } from "../Common/PaymentLinksDailogs";
import { useLocation, useNavigate } from "react-router-dom";
import ComboRefundDialog from "../Common/ComboRefundDialog";
import PartialRefundDialog from "../Common/PartialRefundDialog";
import ShowMultiDayChefitRefundAmountDailog from "../Common/ShowMultiDayChefitRefundAmountDailog";
import UpdateSalesOwnerDialog from "../Common/UpdateSalesOwnerDialog";
import { useAppSelector } from "../../store/hooks";
import GroupPermissionFunction from "../../utils/groupPermissionFunction";
import { UserGroupsEnum } from "../../enums/UserGroupsEnum";
import ApproveSalesDialog from "../Common/ApproveSalesDialog";
import ComboSalesDetails from "./ComboSalesDetails";
import CookAuditLogs from "../Cooks/CookAuditLogs";
import ExtendCouponExpiryDialog from "../Common/ExtendCouponExpiryDialog";
import ComboCouponExtensionsTab from "./ComboCouponExtensionsTab";
import ComboLapsedVists from "./ComboLapsedVisits";
import ComboRefundsTab from "./ComboRefundsTab";
import MarkComboPaidDialog from "../Common/MarkComboPaidDialog";
import { PaymentStatusEnum } from "../../enums/PaymentStatusEnum";

const comboService = new ComboService();

const CTAButtons = (props: any) => {
  const navigate = useNavigate();
  const userDetails = useAppSelector((state) => state.userDetails.value);
  let groupsArray: string[] = userDetails.adminUser.accessGroups;
  let record = useRecordContext();
  // const refresh = useRefresh();

  const onClickSendPaymentLink = () => {
    EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
      message: "Are you sure you want to send the payment link?",
      onClose: (confirmed: boolean) => {
        if (confirmed) {
          comboService
            .sendPaymentLink(parseInt((record as any).id))
            .then((res) => {
              props.setPaymentDialog(true);
              props.setPaymentLinks(res);
              EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Payment link sent",
                type: CustomSnackbarTypes.SUCCESS,
              });
            });
        }
      },
      title: "Confirmation",
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        gap: 10,
        margin: 6,
      }}
    >
      <Button
        variant={"contained"}
        color={"primary"}
        onClick={() => {
          props.setRefundModel(true);
          props.setSelectedData(record);
        }}
      >
        {"Refund Pack"}
      </Button>

      <Button
        variant={"contained"}
        color={"warning"}
        disabled={!record?.razorpayOrder || record?.razorpayOrder?.state !== 'PAID'}
        onClick={() => {
          props.setPartialRefundOpen(true);
          props.setSelectedData(record);
        }}
      >
        {"Partial Refund"}
      </Button>

      <Button
        variant={"contained"}
        color={"primary"}
        onClick={() => {
          props.setUpdateSalesOwnerDialog(true);
          props.setSelectedData(record);
        }}
      >
        {"Update Sales Owner"}
      </Button>
      <Button
        variant={"contained"}
        color={"primary"}
        onClick={() => {
          props.setExtendCouponExpiryDialog(true);
          props.setSelectedData(record);
        }}
      >
        {"Extend Coupon"}
      </Button>
      <Button
        variant={"contained"}
        color={"primary"}
        onClick={() => {
          if (record?.paymentStatus !== "PAID") {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: "Order is not PAID yet",
              type: CustomSnackbarTypes.ERROR,
            });
          } else {
            navigate(
              `/CouponsV2/${record?.orderDetailsData?.[record?.orderDetailsData?.length - 1]?.discountCouponId}/edit`,
            );
          }
        }}
      >
        {"Edit Coupon"}
      </Button>
      <Button
        variant={"contained"}
        color={"primary"}
        onClick={onClickSendPaymentLink}
      >
        {"Send Payment link"}
      </Button>

      {GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN]) && (
        <Button
          variant={"contained"}
          color={"primary"}
          onClick={() => {
            props.setApproveSalesAttributionDialog(true);
            props.setSelectedData(record);
          }}
        >
          {"Approve Sales Attribution"}
        </Button>
      )}
      {GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN]) && (
        <Button
          variant={"contained"}
          color={"success"}
          disabled={
            !record ||
            ![
              PaymentStatusEnum.NOT_PAID,
              PaymentStatusEnum.PAYMENT_IN_PROGRESS,
            ].includes(record?.paymentStatus)
          }
          onClick={() => {
            props.setMarkComboPaidDialog(true);
            props.setSelectedData(record);
          }}
        >
          {"Mark as Paid"}
        </Button>
      )}
      {record ? (
        <Button
          variant={"contained"}
          color={"primary"}
          onClick={() => {
            props.setSelectedData(record);
            props.setOpenRefundAmountTab(true);
          }}
        >
          {"Calculate Refund Amount"}
        </Button>
      ) : (
        <></>
      )}
    </div>
  );
};

const AreaTab = () => {
  let location = useLocation();
  let comboId = location.pathname.split("/")[2];
  const userDetails = useAppSelector((state) => state.userDetails.value);
  let groupsArray: string[] = userDetails.adminUser.accessGroups;
  return (
    <TabbedShowLayout syncWithLocation={false}>
      <Tab label={"Details"} key={"Details"}>
        <ComboMetaShow />
      </Tab>
      <Tab label={"Sales Details"} key={"SaleDetails"}>
        <ComboSalesDetails />
      </Tab>
      <Tab label={"Coupon Extensions"} key={"CouponExtensions"}>
        <ComboCouponExtensionsTab />
      </Tab>
      {GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN]) && (
        <Tab label={"Audit Logs"}>
          <CookAuditLogs referenceId={Number(comboId)} referenceModel="Combo" />
        </Tab>
      )}
      <Tab label={"Lapsed Visits"}>
        <ComboLapsedVists referenceId={Number(comboId)}/>
      </Tab>
      <Tab label={"Refunds"}>
        <ComboRefundsTab />
      </Tab>
    </TabbedShowLayout>
  );
};

function ComboShow(props: any) {
  const refresh = useRefresh();
  const [selectedData, setSelectedData] = useState<any>(null);
  const [refundModel, setRefundModel] = useState<boolean>(false);
  const [partialRefundOpen, setPartialRefundOpen] = useState<boolean>(false);
  let [openRefundAmountTab, setOpenRefundAmountTab] = useState<boolean>(false);
  const [updateSalesOwnerDialog, setUpdateSalesOwnerDialog] =
    useState<boolean>(false);
  const [approveSalesAttributionDialog, setApproveSalesAttributionDialog] =
    useState<boolean>(false);
  const [extendCouponExpiryDialog, setExtendCouponExpiryDialog] =
    useState<boolean>(false);
  const [markComboPaidDialog, setMarkComboPaidDialog] =
    useState<boolean>(false);

  let [paymentDialog, setPaymentDialog] = useState<boolean>(false);
  let [paymentLinks, setPaymentLinks] = useState();

  return (
    <>
      {paymentDialog && (
        <PaymentLinkDailog
          data={paymentLinks}
          open={paymentDialog}
          callback={(data) => {
            setPaymentDialog(false);
          }}
        />
      )}
      {refundModel && (
        <ComboRefundDialog
          data={selectedData}
          open={refundModel}
          callback={() => {
            setRefundModel(false);
            refresh();
          }}
        />
      )}
      {partialRefundOpen && selectedData && (
        <PartialRefundDialog
          open={partialRefundOpen}
          razorpayOrderId={selectedData?.razorpayOrderId}
          maxRefundable={
            Number(selectedData?.razorpayOrder?.amount || 0) -
            Number(selectedData?.razorpayOrder?.refundAmount || 0)
          }
          onClose={() => setPartialRefundOpen(false)}
          onSuccess={() => {
            setPartialRefundOpen(false);
            refresh();
          }}
        />
      )}
      {openRefundAmountTab && (
        <ShowMultiDayChefitRefundAmountDailog
          openRefundAmountTab={openRefundAmountTab}
          callback={() => {
            setOpenRefundAmountTab(false);
          }}
          selectedData={selectedData}
        />
      )}
      {approveSalesAttributionDialog && (
        <ApproveSalesDialog
          open={approveSalesAttributionDialog}
          setOpen={setApproveSalesAttributionDialog}
          data={selectedData}
        />
      )}
      {extendCouponExpiryDialog && (
        <ExtendCouponExpiryDialog
          open={extendCouponExpiryDialog}
          comboOrderId={selectedData?.id}
          onClose={() => setExtendCouponExpiryDialog(false)}
          onSuccess={() => refresh()}
        />
      )}
      {markComboPaidDialog && (
        <MarkComboPaidDialog
          open={markComboPaidDialog}
          comboOrderId={selectedData?.id}
          amount={selectedData?.amount}
          customerPhone={selectedData?.customerData?.mobile}
          onClose={() => setMarkComboPaidDialog(false)}
          onSuccess={() => refresh()}
        />
      )}
      {updateSalesOwnerDialog && (
        <UpdateSalesOwnerDialog
          open={updateSalesOwnerDialog}
          setOpen={setUpdateSalesOwnerDialog}
          data={selectedData}
        />
      )}
      <Show actions={false}>
        <CTAButtons
          setSelectedData={setSelectedData}
          setPaymentDialog={setPaymentDialog}
          setPaymentLinks={setPaymentLinks}
          setRefundModel={setRefundModel}
          setPartialRefundOpen={setPartialRefundOpen}
          setOpenRefundAmountTab={setOpenRefundAmountTab}
          setUpdateSalesOwnerDialog={setUpdateSalesOwnerDialog}
          setApproveSalesAttributionDialog={setApproveSalesAttributionDialog}
          setExtendCouponExpiryDialog={setExtendCouponExpiryDialog}
          setMarkComboPaidDialog={setMarkComboPaidDialog}
        />
        <AreaTab />
      </Show>
    </>
  );
}

export default ComboShow;
